import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDriverAuth } from "../../context/DriverAuthContext";
import { driverAuthAPI } from "../../services/driverAPI";
import "./DriverAuth.css";

export default function DriverLogin() {
  const { login } = useDriverAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await driverAuthAPI.login(email, password);

      if (data.token) {
        if (data.user?.role !== "driver") {
          setError("Access denied. This portal is for drivers only.");
          return;
        }

        login(data.user, data.token);
        navigate("/driver/dashboard");
      } else {
        setError(data.error || "Invalid credentials.");
      }
    } catch {
      setError("Connection error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="driver-auth-bg">
      <div className="driver-auth-glow" />
      <div className="driver-auth-card">
        {/* Logo strip */}
        <div className="driver-auth-logo">
          <span className="logo-icon">🚗</span>
          <span className="logo-text">CarYugo</span>
          <span className="logo-badge">Driver</span>
        </div>

        <h1 className="driver-auth-title">Welcome Back</h1>
        <p className="driver-auth-sub">Sign in to your driver portal</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleEmailLogin} className="auth-form">
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="driver@caryugo.com"
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? <span className="btn-spinner" /> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}